export const isPrivateInvitationToken = (token) => /^[a-f0-9]{64}$/.test(token || "");

export const safeInvitationRedirect = (path) => {
  if (typeof path !== "string" || !path.startsWith("/") ||
      path.startsWith("//") || /[\\\s]/.test(path)) return "/user/courses";
  return path;
};

export const getPrivateInvitationMode = ({ token, invitation, user, loading, signingIn }) => {
  if (!isPrivateInvitationToken(token)) return "invalid";
  if (loading) return "loading";
  if (!invitation) return "invalid";
  if (user) {
    return user.email?.toLowerCase() === invitation.email?.toLowerCase()
      ? "continue" : "switch_account";
  }
  return signingIn ? "sign_in" : "continue";
};

// Called only after Continue, or after sign-in initiated from that button.
export const continuePrivateInvitation = async ({ token, invitation, user, exchange, verifyOtp, claim }) => {
  if (!isPrivateInvitationToken(token)) throw new Error("This invitation link is invalid.");
  if (user && user.email?.toLowerCase() !== invitation.email?.toLowerCase()) {
    throw new Error("Sign out to use the invited email address.");
  }
  if (!user) {
    const result = await exchange(token);
    if (result.mode === "sign_in") return result;
    if (result.mode !== "verify" || !result.token_hash) {
      throw new Error("This invitation could not be accepted. Please try again.");
    }
    const { error } = await verifyOtp({ token_hash: result.token_hash, type: "magiclink" });
    if (error) throw new Error("This sign-in link has expired. Please try Continue again.");
  }
  const result = await claim(token);
  if (!result.success) throw new Error("This invitation could not be accepted. Please try again.");
  return { mode: "complete", redirectTo: safeInvitationRedirect(result.redirectTo) };
};
